module.exports = __webpack_public_path__ + "img/trumpet.be5030ca.webp";